import Vue from 'vue';
const state = {
  p: [], // 프로젝트 ID 배열
  s: [], // 사이트 ID 배열
  d: [], // 고유 day 값(s.id_d.name) 배열
  site:[], // 현재 위치
  report:undefined // 현재 리포트
};

const getters = {
  // 한 리스트의 active여부에 대한 판단
  isActive: (state) => (projectId, siteId, dayName, reportId) => {
    // console.log("isActive:", projectId, siteId, dayName, reportId, state);
    const dayKeyFormatted = '';
    // console.log("isActive:", projectId, siteId, dayName, reportId);
    if(siteId && dayName){
      // console.log('isActive', state);
      const dayKeyFormatted = `${siteId}_${dayName}`;
      siteId = '';
      return state.d.includes(dayKeyFormatted);
    }

    if(projectId){
      return state.p.includes(projectId);
    }

    if(siteId){
      // console.log("siteId",siteId, state.s.includes(siteId));
      return state.s.includes(siteId);
    }

    if(reportId){
      return state?.report?.id == reportId;
    }
    else return false;
  },
  getReportId:(state) => {
    if(state?.report?.id) return state.report.id;
    else return undefined;
  },
  getReportName: (state) => {
    console.log('테스트 getReportName', state);
    return state.reportName;
  },
  getSite :(state) => {
    return state.site;
  },
  getReport:(state) => {
    return state.report;
  }
};

const mutations = {
  // 활성화 또는 비활성화 처리
  TOGGLE_ACTIVE(state, { projectId, siteId, dayName, reportId }) {
    console.log('TOGGLE_ACTIVE', projectId, siteId, dayName, reportId, state);
    //아래 4가지 처리중 하나만 처리하고 return
    // day 처리
    if(siteId && dayName?.length>0){
      console.log('day처리',siteId, dayName);
      const dayKeyFormatted = `${siteId}_${dayName}`;
      if (state.d.includes(dayKeyFormatted)) {
        Vue.set(state, 'd', state.d.filter(key => key !== dayKeyFormatted));
      } else {
        Vue.set(state.d, state.d.length, dayKeyFormatted);
      }
      return;
    }

    // project 처리
    if (projectId) {
      console.log('project처리',projectId);
      if (state.p.includes(projectId)) {
        Vue.set(state, 'p', state.p.filter(id => id !== projectId));
      } else {
        Vue.set(state.p, state.p.length, projectId);
      }
      return;
    }

    // site 처리
    if (siteId) {
      console.log('site처리',siteId);
      if (state.s.includes(siteId)) {
        Vue.set(state, 's', state.s.filter(id => id !== siteId));
      } else {
        Vue.set(state.s, state.s.length, siteId);
      }
      return;
    }

    // report 처리
    if (reportId) {
      console.log('report처리',reportId);
      // if (state.reportId.includes(reportId)) {
      //   Vue.set(state, 'r', state.reportId.filter(id => id !== reportId));
      // } else {
      //   Vue.set(state.reportId, state.reportId.length, reportId);
      // }
      if (!state.report) {
        state.report = {
          id: reportId // ID 설정
        };
      } else if (state?.report?.id !== reportId) {
        // report 객체가 이미 존재하지만 ID가 다른 경우 업데이트
        Vue.set(state.report, 'id', reportId);
      } else if (state.report.id === reportId) {
        // 같은 reportId인 경우 undefined로 설정하여 비활성화
        Vue.set(state.report, 'id', undefined);
      }


      if(state?.report?.id&&state?.report?.id !== reportId){
        state.report.id = reportId;
        Vue.set(state.report, 'id', reportId);
      }else if(state.report.id ==reportId){
        Vue.set(state.report, 'id', undefined);
      }
    }
  },
  SET_REPORT_NAME(state, reportName) {
    // console.log('SET_REPORT_NAME', reportName);
    state.reportName = reportName;
  },
  SET_SITE(state, site){
    state.site = site;
  },
  RESET_STATE(state){
    Vue.set(state, 'p', []);
    Vue.set(state, 's', []);
    Vue.set(state, 'd', []);
    Vue.set(state, 'site', []);
    Vue.set(state, 'report', undefined);
  },
  SET_REPORT(state, report){
    state.report = report;
  }
};

const actions = {
  toggleActive({ commit }, { projectId, siteId, dayName, reportId }) {
    // console.log('toggleActive', projectId, siteId, dayName, reportId);
    commit('TOGGLE_ACTIVE', { projectId, siteId, dayName, reportId });
  },
  setSite({
    commit
  }, site) {
    commit('SET_SITE', site);
  },
  setReportName({ commit }, reportName) {
    console.log('테스트 setReportName', reportName);
    commit('SET_REPORT_NAME', reportName);
  },
  resetState({commit}){
    commit('RESET_STATE');
  },
  setReport({commit}, report){
    commit('SET_REPORT', report);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
